// i18n/index.js — vue-i18n (v8) setup for tracko-web.
// Purpose: create the shared VueI18n instance and load the EN messages. The
// deployed pro-ui is a per-namespace-JSON Vue-i18n app (locale dir
// pro-ui/locales/, 64 locales, 34 EN namespace files, 6413 EN leaf keys). Here we
// bundle a demonstration EN subset (src/i18n/en.json) and note where the full set
// goes — the locale JSON is 100% copyable byte-for-byte (see inventory/i18n-map.md).
// Reconstructed from lacak.io deployed behavior; app-specific contract verbatim,
// internal impl re-authored.

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en.json'

Vue.use(VueI18n)

// To add the real corpus: drop pro-ui/locales/<lang>/*.json into src/i18n/locales/
// and merge each namespace under messages[lang]. e.g.
//   import common from './locales/en/common.json'
//   messages.en = { ...messages.en, common }
const messages = {
  en
}

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages,
  // The demonstration subset is intentionally partial; silence the flood of
  // missing-key warnings until the full 6413-key corpus is copied in.
  silentTranslationWarn: true,
  silentFallbackWarn: true
})

export default i18n
